import { corporateCMSApi } from "~/Services";
import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const generateFieldsForNewApi = (hyperlinkIdx: any): ModuleFields[] => {
  console.log("milestones-field", hyperlinkIdx);
  return [
    {
      fieldName: `Image`,
      fieldValue: `image`,
      className: "col-span-6",
      type: "image",
      name: `image`,
      formType: "file",
      usedFileType: "image/*",
      label: `Image`,
      placeholder: "Upload Image",
      validation: { required: "Image is Required" },
    },
    {
      fieldName: `Image Description`,
      fieldValue: `img_desc`,
      className: "col-span-6",
      type: "text",
      name: `img_desc`,
      formType: "richText",
      label: `Image Description`,
      placeholder: "Enter Image Description",
      validation: { required: "Image Description is Required" },
    },
    {
      fieldName: `Hyperlinks`,
      fieldValue: `Hyperlink`,
      type: "dynamicRow",
      className: "col-span-12",
      name: `Hyperlink`,
      formType: "dynamicRow",
      dynamicFormType: "dynamicRow",
      placeholder: "",
      label: `Hyperlinks`,
      rowConfig: hyperlinkIdx.map((_: any, linkIdx: any) => ({
        fields: [
          {
            fieldName: `Text ${linkIdx + 1}`,
            fieldValue: `Hyperlink[${linkIdx}].text`,
            type: "text",
            className: "col-span-6",
            name: `Hyperlink[${linkIdx}].text`,
            formType: "input",
            label: `Text ${linkIdx + 1}`,
            placeholder: "Add Text",
            validation: { required: "Text is Required" },
          },
          {
            fieldName: `Link ${linkIdx + 1}`,
            fieldValue: `Hyperlink[${linkIdx}].link`,
            type: "pdf",
            className: "col-span-6",
            name: `Hyperlink[${linkIdx}].link`,
            formType: "file",
            label: `Link ${linkIdx + 1}`,
            usedFileType: ".pdf",
            placeholder: "Add Hyperlink",
          },
        ],
      })),
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ];
};

export let getData: { [key in ModuleConfig]: ModuleFields[] } | null = null;

const fetchNewApiData = async (id: any): Promise<{ [key in ModuleConfig]: ModuleFields[] } | null> => {
  try {
    if (!id) {
      const basicHyperlink = [
        {
          fields: [
            {
              fieldName: `Text 1`,
              fieldValue: `Hyperlink[0].text`,
              type: "text",
              className: "col-span-6",
              name: `Hyperlink[0].text`,
              formType: "input",
              label: `Text 1`,
              placeholder: "Add Text",
              validation: { required: "Text is Required" },
            },
            {
              fieldName: `Link 1`,
              fieldValue: `Hyperlink[0].link`,
              type: "pdf",
              className: "col-span-6",
              name: `Hyperlink[0].link`,
              formType: "file",
              label: `Link 1`,
              usedFileType: ".pdf",
              placeholder: "Add Hyperlink",
            },
          ],
        },
      ];
      const basicFields = generateFieldsForNewApi(basicHyperlink);
      return {
        milestones: basicFields.flat() as ModuleFields[],
      };
    }

    const res = await corporateCMSApi.get(`/api/malaysia-airports-training-academy4/${id}`);
    const profileData = res.data;
    const fields = generateFieldsForNewApi(profileData?.[0]?.Hyperlink || []) || [];

    return {
      milestones: fields.flat() as ModuleFields[],
    };
  } catch (error) {
    return null;
  }
};

export const getMilestonesDrilldowndata = async (id: any) => {
  const getData = await fetchNewApiData(id);
  return getData;
};
